<div class="consensus-bar">
  <div class="bar-container">
    <div
      class="forcast-excluded"
      [style.width.px]="forcastExcludedWidth"
      [title]="forcastExcludedTitle"
    ></div>
    <div
      class="forcast-used"
      [title]="forcastUsedTitle"
      [style.width.px]="forcastUsedWidth"
    ></div>
    <div
      class="forcast-inferred"
      [title]="forcastInferredTitle"
      [style.width.px]="forcastInferredWidth"
    ></div>
    <div
      class="forcast-blank"
      [title]="forcastBlankTitle"
      [style.width.px]="forcastBlankWidth"
    ></div>
  </div>
</div>
